import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectIndexListGroup from '../ProjectIndexListGroup';
import ConsultantProjectIndexRow from '../ConsultantProjectIndexRow';
var emptyEditsRequestedText = 'After you submit proposals to projects, both Clora and the employer are able to request additional information from you. When this happens, we will add them here so you can review and address the feedback.';
var emptyDraftText = 'The proposals in this section are ones that you are currently filling out, but have not submitted to Clora yet.';
var ConsultantProjectIndexContainer = /*#__PURE__*/function (_Component) {
  function ConsultantProjectIndexContainer(props) {
    var _this;
    _classCallCheck(this, ConsultantProjectIndexContainer);
    _this = _callSuper(this, ConsultantProjectIndexContainer, [props]);
    _this.state = {
      drafting: props.projects.drafting || [],
      submitted: props.projects.submitted || [],
      edits_requested: props.projects.edits_requested || [],
      introduction: props.projects.introduction || [],
      awarded: props.projects.awarded || [],
      rejected: (props.projects.rejected || []).concat(props.projects.interest_rejected || []),
      interested: (props.projects.interest_pending || []).concat(props.projects.interest_approved || [])
    };
    return _this;
  }
  _inherits(ConsultantProjectIndexContainer, _Component);
  return _createClass(ConsultantProjectIndexContainer, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        drafting = _this$state.drafting,
        submitted = _this$state.submitted,
        edits_requested = _this$state.edits_requested,
        awarded = _this$state.awarded,
        rejected = _this$state.rejected,
        interested = _this$state.interested;
      var proposalsExist = drafting.length || submitted.length || edits_requested.length || awarded.length || rejected.length;
      if (!proposalsExist && interested.length > 0) {
        return ConsultantProjectIndexContainer.listGroup(interested, 'interested');
      }
      return /*#__PURE__*/React.createElement("div", null, interested.length > 0 && ConsultantProjectIndexContainer.listGroup(interested, 'interested'), ConsultantProjectIndexContainer.listGroup(edits_requested, 'edits_requested'), ConsultantProjectIndexContainer.listGroup(drafting, 'drafting'), /*#__PURE__*/React.createElement("div", {
        className: "mt-50"
      }), ConsultantProjectIndexContainer.listGroup(submitted, 'submitted'), ConsultantProjectIndexContainer.listGroup(awarded, 'awarded'), rejected.length > 0 && ConsultantProjectIndexContainer.listGroup(rejected, 'rejected'));
    }
  }], [{
    key: "statusConfig",
    value: function statusConfig(status) {
      return {
        interested: {
          groupClass: 'bg-tertiary-emphasis',
          title: 'Resume Submitted',
          useLengthForExpanded: true
        },
        edits_requested: {
          groupClass: 'bg-warning',
          title: 'Feedback',
          useLengthForExpanded: true,
          partialEmptyTitle: 'proposals with feedback.',
          emptyText: emptyEditsRequestedText
        },
        drafting: {
          groupClass: 'bg-default',
          title: 'Proposal Drafts',
          useLengthForExpanded: true,
          partialEmptyTitle: 'proposals that are in progress.',
          emptyText: emptyDraftText
        },
        submitted: {
          groupClass: 'bg-accent-fallback-tertiary',
          title: 'Submitted',
          useLengthForExpanded: false,
          partialEmptyTitle: 'submitted proposals.'
        },
        awarded: {
          groupClass: 'bg-accent-primary',
          title: 'Awarded',
          useLengthForExpanded: false,
          partialEmptyTitle: 'accepted proposals.'
        },
        rejected: {
          groupClass: 'bg-default',
          title: 'Not Accepted',
          useLengthForExpanded: false
        }
      }[status];
    }
  }, {
    key: "listGroup",
    value: function listGroup(projects, status) {
      var _ConsultantProjectInd = ConsultantProjectIndexContainer.statusConfig(status),
        groupClass = _ConsultantProjectInd.groupClass,
        title = _ConsultantProjectInd.title,
        useLengthForExpanded = _ConsultantProjectInd.useLengthForExpanded,
        partialEmptyTitle = _ConsultantProjectInd.partialEmptyTitle,
        emptyText = _ConsultantProjectInd.emptyText;
      return /*#__PURE__*/React.createElement(ProjectIndexListGroup, {
        count: projects.length,
        classes: groupClass,
        status: status,
        title: title,
        expand: useLengthForExpanded && projects.length > 0
      }, projects.map(function (project) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: project.resource_id
        }, /*#__PURE__*/React.createElement(ConsultantProjectIndexRow, {
          name: project.name,
          projectLink: project.project_link,
          proposal: project.proposal,
          status: status,
          aoe: project.area_of_expertise,
          hours: project.avg_weekly_time,
          location: project.work_location
        }));
      }), projects.length === 0 && partialEmptyTitle && /*#__PURE__*/React.createElement("li", {
        className: "list-group-item"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text-muted mb-2"
      }, "You currently have 0", partialEmptyTitle, "."), emptyText && /*#__PURE__*/React.createElement("h6", {
        className: "text-muted"
      }, emptyText)));
    }
  }]);
}(Component);
ConsultantProjectIndexContainer.propTypes = {
  projects: PropTypes.shape({
    drafting: PropTypes.arrayOf(PropTypes.shape({})),
    submitted: PropTypes.arrayOf(PropTypes.shape({})),
    edits_requested: PropTypes.arrayOf(PropTypes.shape({})),
    introduction: PropTypes.arrayOf(PropTypes.shape({})),
    awarded: PropTypes.arrayOf(PropTypes.shape({})),
    rejected: PropTypes.arrayOf(PropTypes.shape({})),
    interest_pending: PropTypes.arrayOf(PropTypes.shape({})),
    interest_approved: PropTypes.arrayOf(PropTypes.shape({})),
    interest_rejected: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};
export default ConsultantProjectIndexContainer;